//
//
//
//
//
//

function buildThresholdList() {
  const thresholds = [];
  const numSteps = 20;

  for (let i = 1.0; i <= numSteps; i++) {
    const ratio = i / numSteps;
    thresholds.push(ratio);
  }

  thresholds.push(0);
  return thresholds;
}
export default {
  props: {
    url: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      player: null,
    };
  },
  destroyed() {
    this.player.destroy();
    this.player = null;
  },
  mounted() {
    this.initPlayer();
  },
  methods: {
    initPlayer() {
      const Player = require('xgplayer');
      this.player = new Player({
        id: 'mg-player',
        url: this.url,
        playsinline: true,
        autoplay: true,
        fitVideoSize: 'width',
        videoInit: true,
        autoplayMuted: true,
        fluid: true,
        loop: true,
      });
      this.player.once('complete', () => {
        this.initObeserver();
      });
    },
    initObeserver() {
      const video = document.getElementById('mg-player');
      if (!video || !IntersectionObserver) return;
      const callback = (entrys) => {
        entrys.forEach((entry) => {
          if (entry.intersectionRatio <= 0.45) {
            if (!this.player?.paused) this.player?.pause();
          } else if (this.player?.paused) this.player?.play();
        });
      };
      const obeserver = new IntersectionObserver(callback, {
        root: null,
        threshold: buildThresholdList(),
      });

      obeserver.observe(video);
    },
    loaded() {
      this.initObeserver();
    },
    errorHandle() {},
  },
};
